import { render, staticRenderFns } from "./ChooseCustomerDialog.vue?vue&type=template&id=51b49b9f&scoped=true&"
import script from "./ChooseCustomerDialog.vue?vue&type=script&lang=ts&"
export * from "./ChooseCustomerDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b49b9f",
  null
  
)

export default component.exports